<div class="row pb-3" *ngIf="transport">
  <div class="col-12">
    <jhi-bary-card [title]="'baryApp.transport-card.offer.title' | translate: { offerName: transport.offerName ?? 'NC' }" [icon]="getTransportTypeIcon()">
      <div body [class]="customer && checkIfIsAllowedToShowPricingBloc() ? 'grid-container-4-cols' : 'grid-container-3-cols'">
        <div class="p-1 px-0">
          <jhi-bary-card titleKey="baryApp.transport-card.pickup.title" icon="truck-loading">
            <div body>
              <p class="bold mb-1" *ngIf="(transport | transportPeriod: { pickup: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.date"></span> :</p>
              <p [innerHTML]="transport | transportPeriod: { pickup: true }"></p>
              <p class="bold mb-1" *ngIf="(transport | transportAddress: { pickup: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.address"></span> :</p>
              <p [innerHTML]="transport | transportAddress: { pickup: true }"></p>
              <p class="bold mb-1" *ngIf="(transport | transportContact: { pickup: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.contact"></span> :</p>
              <p [innerHTML]="transport | transportContact: { pickup: true }"></p>
              <p class="bold mb-1" *ngIf="(transport | transportConstraints: { pickup: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.constraints"></span> :</p>
              <p [innerHTML]="transport | transportConstraints: { pickup: true }"></p>
              <p class="bold mb-1" *ngIf="transport.pickupReference">
                <span jhiTranslate="baryApp.transport-card.detail.reference"></span> :
                <span class="font-weight-normal">{{ transport.pickupReference }}</span>
              </p>
            </div>
          </jhi-bary-card>
        </div>
        <div class="p-1 px-0">
          <jhi-bary-card titleKey="baryApp.transport-card.delivery.title" icon="shipping-fast">
            <div body>
              <p class="bold mb-1" *ngIf="(transport | transportPeriod: { delivery: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.date"></span> :</p>
              <p [innerHTML]="transport | transportPeriod: { delivery: true }"></p>
              <p class="bold mb-1" *ngIf="(transport | transportAddress: { delivery: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.address"></span> :</p>
              <p [innerHTML]="transport | transportAddress: { delivery: true }"></p>
              <p class="bold mb-1" *ngIf="(transport | transportContact: { delivery: true }) !== ''"><span jhiTranslate="baryApp.transport-card.detail.contact"></span> :</p>
              <p [innerHTML]="transport | transportContact: { delivery: true }"></p>
              <p class="bold mb-1" *ngIf="(transport | transportConstraints: { delivery: true }) !== ''">
                <span jhiTranslate="baryApp.transport-card.detail.constraints"></span> :
              </p>
              <p [innerHTML]="transport | transportConstraints: { delivery: true }"></p>
              <p class="bold mb-1" *ngIf="transport.deliveryReference">
                <span jhiTranslate="baryApp.transport-card.detail.reference"></span> :
                <span class="font-weight-normal">{{ transport.deliveryReference }}</span>
              </p>
            </div>
          </jhi-bary-card>
        </div>
        <div class="p-1 px-0">
          <jhi-bary-card titleKey="baryApp.transport-card.items.title" icon="box">
            <div body>
              <div *ngIf="transport.itemsNature">
                <p class="bold mb-1"><span jhiTranslate="baryApp.transport-card.items.natureTitle"></span> :</p>
                <p>{{ transport.itemsNature }}</p>
              </div>
              <div *ngIf="transport.goodsValue">
                <p class="bold mb-1"><span jhiTranslate="baryApp.transport-card.items.insurance.title"></span> :</p>
                <p class="mb-1">
                  <span jhiTranslate="baryApp.transport-card.items.insurance.goodsValue"></span>
                  :
                  {{ transport.goodsValue | currency: 'EUR' }}
                </p>
                <p class="mb-1" *ngIf="isTransportOrder(transport) && transport.insurance">
                  <span jhiTranslate="baryApp.transport-card.items.insurance.price"></span> :
                  {{ transport.insurance | currency: 'EUR' }}
                </p>
                <p class="mb-1" *ngIf="transport.itemsCondition">
                  <span jhiTranslate="baryApp.transport-card.items.insurance.itemsCondition"></span>
                  :
                  {{ 'baryApp.itemCondition.' + transport.itemsCondition | translate }}
                </p>
                <p></p>
              </div>
              <div *ngIf="transport.items.length > 0">
                <p class="bold mb-1"><span jhiTranslate="baryApp.transport-card.items.itemsListTitle"></span> :</p>
                <ul class="list-unstyled">
                  <li *ngFor="let item of transport.items" class="mb-1">
                    <p class="mb-1">
                      <span *ngIf="item">
                        {{ item.quantity ? item.quantity + ' ' : '' }}
                        {{ item.quantity ? ('baryApp.HandlingType.' + item.handlingType | translate) : ''
                        }}{{ item.quantity && item.quantity > 1 && item.handlingType === 'PALLET' ? 's' : '' }} {{ item.width && item.length ? item.width + 'x' + item.length : ''
                        }}{{ item.width && item.length && item.maxHeight ? 'x' + item.maxHeight : '' }}
                        {{ item.weight ? item.weight + 'kg' : '' }}
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                <p class="bold mb-1"><span jhiTranslate="baryApp.transport-card.items.total.title"></span> :</p>
                <p [innerHTML]="transport | transportTotal"></p>
              </div>
              <div *ngIf="transport.serviceType === LIST_SERVICE_TYPE['FTL'] && transport.items.length > 0">
                <p class="bold mb-1"><span jhiTranslate="TRANSPORT_CARD.VEHICLE"></span> :</p>
                <ul class="list-unstyled">
                  <li *ngFor="let item of transport.items" class="mb-1">
                    <p class="mb-1">
                      <span *ngIf="item.vehicleCategory && item.vehicleType"> {{ item.vehicleCategory.labelKey | translate }} - {{ item.vehicleType.labelKey | translate }} </span>
                      <span *ngIf="item.otherVehicleType">
                        {{ item.otherVehicleType }}
                      </span>
                      <span *ngIf="!item.otherVehicleType && !item.vehicleCategory && !item.vehicleType">{{ 'TRANSPORT_CARD.VEHICLE.NO_DETAIL' | translate }}</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div *ngIf="transport.euroPallet && transport.euroPallet > 0">
                <p class="bold mb-1"><span jhiTranslate="baryApp.transport-card.items.options.title"></span> :</p>
                <p class="mb-1"><span jhiTranslate="baryApp.transport-card.items.options.euroPallet"></span></p>
              </div>
            </div>
          </jhi-bary-card>
        </div>
        <div *ngIf="customer && checkIfIsAllowedToShowPricingBloc()" class="p-1 px-0">
          <jhi-transport-card-bill [transport]="transport"></jhi-transport-card-bill>
        </div>
      </div>
      <div class="row pt-2" *ngIf="transport.isControlledTemperature || transport.isControlledTemperature">
        <div class="col-12">
          <jhi-bary-card [title]="'baryApp.transport-card.modalite.title' | translate: { transportTypology: ('transport-typology.' + transport.transportTypology | translate) }">
            <div body>
              <table [responsive]="true" mdbTable [borderless]="true" *ngIf="transport.isHazardousMaterial">
                <thead [align]="'left'">
                  <tr>
                    <th class="not-tablet" [width]="20"></th>
                    <th>Quantité limitée</th>
                    <th>Code ONU</th>
                    <th class="not-tablet">Description</th>
                    <th>Emballage</th>
                    <th>Nombre d'emballage</th>
                    <th>Groupe d'emballage</th>
                    <th>Dangereux pour l'environnement</th>
                    <th>Déchet</th>
                    <th>Quantité nette (kg/L)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr [align]="'left'" *ngFor="let extraCondition of transport.transportExtraConditions; let index = index">
                    <td class="not-tablet">{{ index + 1 }}</td>
                    <td>
                      <b>{{ extraCondition.adrIsLimitedQuantity! | transformBooleanToYesOrNo }}</b>
                    </td>
                    <td>{{ extraCondition.adrCodeUN }}</td>
                    <td class="not-tablet">{{ extraCondition.adrDescription }}</td>
                    <td>{{ extraCondition.adrPacking }}</td>
                    <td>{{ extraCondition.adrPackingNumber }}</td>
                    <td>{{ extraCondition.adrPackingGroup }}</td>
                    <td>{{ extraCondition.adrIsDangerousForEnvironment ?? false | transformBooleanToYesOrNo }}</td>
                    <td *ngIf="extraCondition.adrWasteBsdCode">
                      {{ (extraCondition.adrIsWaste ?? false | transformBooleanToYesOrNo) + ' - ' + extraCondition.adrWasteBsdCode }}
                    </td>
                    <td *ngIf="!extraCondition.adrWasteBsdCode">{{ extraCondition.adrIsWaste ?? false | transformBooleanToYesOrNo }}</td>
                    <td>
                      <b>{{ extraCondition.adrNetWeight }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <span *ngIf="transport.isControlledTemperature && transport.transportExtraConditions && transport.transportExtraConditions.length > 0">
                Température : {{ transport.transportExtraConditions[0].controlledTemperature }}
              </span>
            </div>
          </jhi-bary-card>
        </div>
      </div>
    </jhi-bary-card>
  </div>
</div>
